export enum EShippingAddressFormItem {
    NAME = "name",
    ZIP_CODE = "zip-code",
    CITY = "city",
    STREET = "street",
    PHONE = "phone",
    MESSAGE_FOR_THE_COURIER = "message-for-the-courier",
}
